module.exports = __webpack_public_path__ + "media/auto_history/rok_produkcji-7dbc2194.png";